import axios from "axios";

axios.defaults.headers = {
    'Authorization':'Bearer ' + localStorage.getItem('token'),
    'Accept':'application/json',
}

// Дозволені розміри сторінки — ті самі, що у ReportRequest на backend.
export const PER_PAGE_OPTIONS = [10, 25, 50, 100, 150, 200, 300, 500];
export const DEFAULT_PER_PAGE = 25;
export const PER_PAGE_STORAGE_KEY = 'crm.stats_orders.per_page';

function readStoredPerPage() {
    try {
        const stored = Number(localStorage.getItem(PER_PAGE_STORAGE_KEY));
        return PER_PAGE_OPTIONS.includes(stored) ? stored : DEFAULT_PER_PAGE;
    } catch (e) {
        return DEFAULT_PER_PAGE;
    }
}

const state = {
    prepareFilters: null,
    report: null,
    // Останні застосовані фільтри (snapshot на момент кнопки «Побудувати звіт»).
    appliedFilters: null,
    page: 1,
    products_page: 1,
    per_page: readStoredPerPage(),
    loading: false,
    error: null,
    // Послідовність запитів: відповідь зі старою sequence ігнорується.
    requestSequence: 0,
};

const getters = {
    prepareFilters: state => state.prepareFilters,
    report: state => state.report,
    orders: state => state.report ? state.report.orders : [],
    products: state => state.report ? state.report.products : [],
    pagination: state => state.report ? state.report.pagination : null,
    productsPagination: state => state.report ? state.report.products_pagination : null,
    totals: state => state.report ? state.report.totals : null,
    charts: state => state.report ? state.report.charts : null,
    appliedFilters: state => state.appliedFilters,
    page: state => state.page,
    productsPage: state => state.products_page,
    perPage: state => state.per_page,
    loading: state => state.loading,
    error: state => state.error,
};

const actions = {

    //begin order-status

    getPrepareFilters: async ({commit}, options) =>{
        let url = '/report/prepare_filters'
        if(options) {
            url = `/report/prepare_filters`
        }
        try{
            const result = await axios.get(url);
            commit('changePrepareFilters', result.data.models);
        }catch (e){
            console.log(e)
            throw e
        }
    },

    /**
     * Побудувати звіт: фіксує фільтри та скидає обидві сторінки на 1.
     */
    buildReport: async ({commit, dispatch}, filters) =>{
        commit('applyFilters', filters);
        return dispatch('fetchReport');
    },

    changePage: async ({commit, dispatch}, page) =>{
        commit('changePage', page);
        return dispatch('fetchReport');
    },

    changeProductsPage: async ({commit, dispatch}, page) =>{
        commit('changeProductsPage', page);
        return dispatch('fetchReport');
    },

    changePerPage: async ({commit, dispatch}, perPage) =>{
        const value = Number(perPage);
        if (!PER_PAGE_OPTIONS.includes(value)) {
            return;
        }
        try {
            localStorage.setItem(PER_PAGE_STORAGE_KEY, String(value));
        } catch (e) {
            // localStorage може бути недоступним — розмір усе одно застосовується.
        }
        commit('changePerPage', value);
        return dispatch('fetchReport');
    },

    fetchReport: async ({commit, state}) =>{
        if (!state.appliedFilters) {
            return;
        }

        const sequence = state.requestSequence + 1;
        commit('startLoading', sequence);

        const payload = {
            ...state.appliedFilters,
            page: state.page,
            products_page: state.products_page,
            per_page: state.per_page,
        };

        try {
            const result = await axios.post('/report/get_orders', payload);
            if (state.requestSequence !== sequence) {
                // Застаріла відповідь не має перезаписувати актуальну сторінку.
                return;
            }
            commit('changeReport', result.data.models);
            commit('finishLoading', sequence);
        } catch (e) {
            if (state.requestSequence !== sequence) {
                return;
            }
            commit('setError', {sequence, error: e});
            throw e;
        }
    },

}



const mutations = {
    // status-orders
    changePrepareFilters(state, status){
        state.prepareFilters = status[0];
    },
    applyFilters(state, filters){
        state.appliedFilters = filters;
        state.page = 1;
        state.products_page = 1;
    },
    changePage(state, page){
        state.page = page;
    },
    changeProductsPage(state, page){
        state.products_page = page;
    },
    changePerPage(state, perPage){
        state.per_page = perPage;
        state.page = 1;
        state.products_page = 1;
    },
    startLoading(state, sequence){
        state.requestSequence = sequence;
        state.loading = true;
        state.error = null;
    },
    finishLoading(state, sequence){
        if (state.requestSequence === sequence) {
            state.loading = false;
        }
    },
    setError(state, payload){
        if (state.requestSequence === payload.sequence) {
            state.loading = false;
            state.error = payload.error;
        }
    },
    changeReport(state, models){
        state.report = models;
    },
    changes(){
    }
};



export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
